import ClockoutController from '../../core/clockout.controller';
import Inherit from '../../core/inherit';
import ReconciliationDelegate from './reconciliation.delegate';

class ReconciliationController extends Inherit(ClockoutController, ReconciliationDelegate) {
    async initialize() {
        // Check if user has valid data (not just an empty object)
        if (!this.user || !this.user.access || this.user.access.length === 0) {
            this.navigateLogin();
            return;
        }

        this.setState({ user: this.data.user });
        const reconciliation = await this.data.fetchReconciliation();
        console.log(reconciliation);

        // Handle different possible data structures
        const reconciliationData = Array.isArray(reconciliation) ? reconciliation : reconciliation?.transactions || reconciliation?.data || [];

        this.setState({
            reconciliation: reconciliationData,
            rows: reconciliationData,
            loading: false,
        });
    }
}

export default ReconciliationController;
